import type { FunctionComponent } from 'react';

import { Badge } from '~/ui/core/badge/Badge';

import { useChatComposerActive, useChatComposerCallbacks } from '../../../chat/chat-composer-contexts';

const useIsChatContextualPromptVisible = (): boolean => {
    const { isCollapsedComposerOpen, isExpanded: isChatExpanded, promptChatContext } = useChatComposerActive();
    const { isComposerEnabled } = useChatComposerCallbacks();

    return isComposerEnabled && promptChatContext !== null && (isChatExpanded || isCollapsedComposerOpen);
};

// Action badge that dims to a neutral "gray" variant while a contextual chat prompt
// is on screen, so the chat prompt stays the primary call to action.
export const ChatAwareActionBadge: FunctionComponent<{
    readonly disabled?: boolean;
    readonly label: string;
    readonly testId: string;
    readonly variant: 'info' | 'success';
    readonly onClick: () => void;
}> = ({ disabled, label, testId, variant, onClick }) => {
    const isChatContextualPromptVisible = useIsChatContextualPromptVisible();
    return (
        <Badge
            data-testid={testId}
            disabled={disabled}
            variant={isChatContextualPromptVisible ? 'gray' : variant}
            onClick={onClick}
        >
            {label}
        </Badge>
    );
};
